var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.45707 2.26149L3.08722 3.16125C3.08694 2.82018 3.08694 2.61337 3.08694 2.61337L8.45707 1.71589V2.26149ZM8.9993 0L2.54485 1.08025V8.61699C2.16696 8.40591 1.64142 8.37064 1.12793 8.55981C0.30723 8.86347 -0.172042 9.6267 0.0573571 10.267C0.287037 10.9049 1.13831 11.1799 1.95901 10.8763C2.70372 10.6013 3.08624 9.95454 3.08708 9.34963C3.08834 8.19243 3.08778 5.30398 3.08736 3.71126L8.45721 2.8115V7.51711C8.07946 7.30589 7.55392 7.27062 7.04029 7.45993C6.21973 7.7636 5.74031 8.52681 5.96985 9.16714C6.19939 9.80505 7.05081 10.08 7.87151 9.77646C8.61622 9.50139 8.99902 8.85466 8.99944 8.24975C9.0007 6.26988 8.99944 0.000142371 8.99944 0.000142371L8.9993 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.35373dd60b5665978811c5d31e35e88b.svg";
export { ForwardRef as ReactComponent };